var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-modal',{attrs:{"id":_vm.id,"title":"Edit Client"},on:{"show":_vm.resetModal,"hidden":_vm.resetModal,"ok":_vm.handleOk},scopedSlots:_vm._u([{key:"modal-footer",fn:function(ref){
var ok = ref.ok;
var cancel = ref.cancel;
return [_c('b-button',{attrs:{"size":"sm","variant":"secondary"},on:{"click":function($event){return cancel()}}},[_vm._v("Cancel")]),_c('b-button',{staticClass:"bg-site-primary",attrs:{"size":"sm","variant":"primary"},on:{"click":function($event){return ok()}}},[_vm._v("Save")])]}}])},[_c('b-table',{attrs:{"stacked":"","borderless":true,"fields":[
        {
          key: 'id',
          label: 'ID',
          sortable: true
        },
        {
          key: 'username',
          label: 'Name',
          sortable: true
        } ],"items":[_vm.client]},scopedSlots:_vm._u([{key:"cell(username)",fn:function(){return [_c('b-form-input',{attrs:{"type":"text"},model:{value:(_vm.newName),callback:function ($$v) {_vm.newName=$$v},expression:"newName"}})]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }